// Cores da identidade HidroBR (extraídas de public/logo_hidro.png)
export const HidroBrColors = {
    azulEscuro: '#004B6A',
    azul: '#005979',
    verde: '#00906A',
};

// Blocos quadrados translúcidos que remetem aos blocos do "H" do logo
const bloco = 'linear-gradient(rgba(255, 255, 255, 0.05), rgba(255, 255, 255, 0.05))';

// Fundo da aplicação (login e área atrás do cabeçalho das telas): degradê azul -> verde
export const BrandBackground = {
    backgroundColor: HidroBrColors.azul,
    backgroundImage: [
        bloco,
        bloco,
        bloco,
        `linear-gradient(135deg, ${HidroBrColors.azulEscuro} 0%, ${HidroBrColors.azul} 55%, ${HidroBrColors.verde} 100%)`,
    ].join(', '),
    backgroundSize: '32vmin 32vmin, 20vmin 20vmin, 9vmin 9vmin, 100% 100%',
    backgroundPosition: 'left -8vmin top -8vmin, right 10vmin bottom -5vmin, right 34vmin bottom 18vmin, center',
    backgroundRepeat: 'no-repeat',
};
